import _toConsumableArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { getAudioNodeConnections } from './get-audio-node-connections';
import { getAudioNodeRenderer } from './get-audio-node-renderer';
export var renderInputsOfAudioNode = function renderInputsOfAudioNode(audioNode, nativeOfflineAudioContext, nativeAudioNode) {
  var audioNodeConnections = getAudioNodeConnections(audioNode);
  return Promise.all(audioNodeConnections.activeInputs.map(function (connections, input) {
    return Array.from(connections).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          source = _ref2[0],
          output = _ref2[1];

      return getAudioNodeRenderer(source).render(source, nativeOfflineAudioContext).then(function (node) {
        return node.connect(nativeAudioNode, output, input);
      });
    });
  }).reduce(function (allRenderingPromises, renderingPromises) {
    return [].concat(_toConsumableArray(allRenderingPromises), _toConsumableArray(renderingPromises));
  }, []));
};